import React, { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import useKeyboard from '@/modules/corporate/modules/database/fields/hooks/useKeyboard';
import { CellProps } from '@/modules/corporate/modules/database/types';

const Text = forwardRef<HTMLDivElement, CellProps>((props: CellProps, ref) => {
  const { cellData, toggleIsEditing, columnIndex, viewOnly, rowIndex, className } = props;

  const { onKeyDown } = useKeyboard({ onEnterPress: toggleIsEditing });

  return (
    <Stack
      ref={ref}
      className={cn('h-full w-full py-8 pe-6 ps-12', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={toggleIsEditing}
      onKeyDown={onKeyDown}>
      <Typography
        className={viewOnly ? '' : 'truncate'}
        color="text-text-paragraph"
        variant="body-short-02">
        {cellData?.value}
      </Typography>
    </Stack>
  );
});

export default Text;
